import React, { useContext, useEffect, useState } from 'react'
import { LeagueContext } from '../../../../Context'
import { FeedItem } from '../../../../Api'
import { AdditionalHeadlines } from '../../../../Components/Feed/Articles/AdditionalHeadlines'

export const HeadlinesFromLeague: React.FC<React.PropsWithChildren<unknown>> = () => {
  //Setting first trending feed items
  const [headlinesItems, setHeadlinesItems] = useState<FeedItem[]>([])
  const { feed } = useContext(LeagueContext)!

  useEffect(() => {
    if (feed?.trending && feed.trending.length > 1) {
      let items = feed.trending.slice(1)
      setHeadlinesItems(items)
    }
  }, [feed])

  return <>{headlinesItems && <AdditionalHeadlines feedItems={headlinesItems} />}</>
}
